import {
  AdminUsersResponseType,
  ApiClient,
  ApiErrorMessage,
  CategoryResponseType,
  MailingListResponseType,
  PhrasesResponseType,
  SettingsResponseType,
  SignagesResponseType,
  TrainGroupsResponseType,
  TrainsResponseType
} from './ApiClient';

export const GetAdminUsersApi = async (): Promise<AdminUsersResponseType> => {
  try {
    const response = await ApiClient.get('/admin/admin_users', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetTrainsApi = async (): Promise<TrainsResponseType> => {
  try {
    const response = await ApiClient.get('/admin/trains', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetTrainGroupsApi = async (): Promise<TrainGroupsResponseType> => {
  try {
    const response = await ApiClient.get('/admin/train_groups', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetCategoryApi = async (): Promise<CategoryResponseType> => {
  try {
    const response = await ApiClient.get('/admin/categories', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetPhrasesApi = async (): Promise<PhrasesResponseType> => {
  try {
    const response = await ApiClient.get('/admin/phrases', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetMailingListApi = async (): Promise<MailingListResponseType> => {
  try {
    const response = await ApiClient.get('/admin/mailinglists', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetSignagesApi = async (): Promise<SignagesResponseType> => {
  try {
    const response = await ApiClient.get('/admin/signages', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const GetSettingsApi = async (): Promise<SettingsResponseType> => {
  try {
    const response = await ApiClient.get('/admin/settings', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
